<template><router-view /></template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useThemeStore } from '@/store/modules/theme'

// const themeStore = useThemeStore()

// 应用启动时初始化主题
onMounted(() => {
  // themeStore.initTheme()
})
</script>
